import { Customization } from '@/common/types/student';
import Customizations from '@/game/GameComponents/GameData/customizations.json';
import { getCharacterInventory } from '@/game/GameComponents/PhaserGame/GameInstance';
import { loadCustomizationTextures } from '@/game/GameComponents/PhaserGame/Utils/CosmeticUtils';
import DefaultConfirmButton_m from '@/game/prefabs/DefaultConfirmButton_m';
import DefaultDenyButton_m from '@/game/prefabs/GeneralUI/Buttons/DefaultDenyButton_m';
import { PlayerInventoryController } from '@/game/scenes/PlayerInventory/PlayerInventoryController';
import DefaultButton from '../../prefabs/GeneralUI/Buttons/DefaultButton';
import DefaultDenyButton from '../../prefabs/GeneralUI/Buttons/DefaultDenyButton';
import HUDButton from '../../prefabs/GeneralUI/Buttons/HUDButton';
import ComplexionSelection from '../../prefabs/GeneralUI/ComplexionSelection';
import PlayerDoll from '../../prefabs/GeneralUI/PlayerDoll';
import UIBlocker from '../../prefabs/GeneralUI/UIBlocker';

/* START OF COMPILED CODE */

export default class PlayerInventory extends Phaser.Scene {

	constructor() {
		super("PlayerInventory");

		/* START-USER-CTR-CODE */

    /* END-USER-CTR-CODE */
	}

	editorCreate(): void {

		// desktopView
		const desktopView = this.add.container(0, 0);
		desktopView.visible = false;

		// uIBlocker
		const uIBlocker = new UIBlocker(this, 0, 0);
		desktopView.add(uIBlocker);

		// mainContainer
		const mainContainer = this.add.container(512, 384);
		desktopView.add(mainContainer);

		// mainBG
		const mainBG = this.add.nineslice(0, 0, "Hud1", undefined, 250, 172, 8, 8, 8, 8);
		mainBG.scaleX = 4;
		mainBG.scaleY = 4;
		mainContainer.add(mainBG);

		// headerContainer
		const headerContainer = this.add.container(8, -336);
		mainContainer.add(headerContainer);

		// headerBacking
		const headerBacking = this.add.nineslice(0, 0, "Hud2", undefined, 64, 16, 4, 4, 4, 8);
		headerBacking.scaleX = 4;
		headerBacking.scaleY = 4;
		headerContainer.add(headerBacking);

		// bitmaptext_1
		const bitmaptext_1 = this.add.bitmapText(0, 0, "Aronui", "Inventory");
		bitmaptext_1.setOrigin(0.5, 0.5);
		bitmaptext_1.tintTopLeft = 985612;
		bitmaptext_1.tintTopRight = 985612;
		bitmaptext_1.tintBottomLeft = 985612;
		bitmaptext_1.tintBottomRight = 985612;
		bitmaptext_1.text = "Inventory";
		bitmaptext_1.fontSize = -32;
		headerContainer.add(bitmaptext_1);

		// shopTabs
		const shopTabs = this.add.container(-300, -228);
		mainContainer.add(shopTabs);

		// itemDescriptionArea
		const itemDescriptionArea = this.add.container(-480, 88);
		mainContainer.add(itemDescriptionArea);

		// itemNameLabel
		const itemNameLabel = this.add.bitmapText(88, 12, "Aronui", "<Item Name>\n");
		itemNameLabel.setOrigin(0.5, 0);
		itemNameLabel.tintTopLeft = 5387071;
		itemNameLabel.tintTopRight = 5387071;
		itemNameLabel.tintBottomLeft = 5387071;
		itemNameLabel.tintBottomRight = 5387071;
		itemNameLabel.text = "<Item Name>\n";
		itemNameLabel.fontSize = -18;
		itemNameLabel.maxWidth = 170;
		itemDescriptionArea.add(itemNameLabel);

		// mainShopGrid
		const mainShopGrid = this.add.container(-152, -228);
		mainContainer.add(mainShopGrid);

		// gridBacking
		const gridBacking = this.add.nineslice(0, 0, "panel segment", undefined, 155, 119, 4, 4, 4, 8);
		gridBacking.scaleX = 4;
		gridBacking.scaleY = 4;
		gridBacking.setOrigin(0, 0);
		mainShopGrid.add(gridBacking);

		// gridScrollBar
		const gridScrollBar = this.add.container(604, 8);
		mainShopGrid.add(gridScrollBar);

		// scrollBarBacking
		const scrollBarBacking = this.add.nineslice(0, 0, "scrollbar-backing", undefined, 8, 112, 4, 4, 4, 4);
		scrollBarBacking.scaleX = 4;
		scrollBarBacking.scaleY = 4;
		scrollBarBacking.setOrigin(0.5, 0);
		gridScrollBar.add(scrollBarBacking);

		// scrollBarHandle
		const scrollBarHandle = this.add.image(0, 0, "scrollbar-handle");
		scrollBarHandle.scaleX = 4;
		scrollBarHandle.scaleY = 4;
		scrollBarHandle.setOrigin(0.5, 0);
		gridScrollBar.add(scrollBarHandle);

		// content
		const content = this.add.container(-8, 0);
		mainShopGrid.add(content);

		// loadingContainer
		const loadingContainer = this.add.container(0, 0);
		mainShopGrid.add(loadingContainer);

		// spinnerBlocker
		const spinnerBlocker = this.add.image(-148, 0, "1x1sprite");
		spinnerBlocker.scaleX = 768;
		spinnerBlocker.scaleY = 478;
		spinnerBlocker.setOrigin(0, 0);
		spinnerBlocker.alpha = 0.3;
		spinnerBlocker.alphaTopLeft = 0.31;
		spinnerBlocker.alphaTopRight = 0.3;
		spinnerBlocker.alphaBottomLeft = 0.3;
		spinnerBlocker.alphaBottomRight = 0.3;
		spinnerBlocker.tintTopLeft = 985612;
		spinnerBlocker.tintTopRight = 985612;
		spinnerBlocker.tintBottomLeft = 985612;
		spinnerBlocker.tintBottomRight = 985612;
		loadingContainer.add(spinnerBlocker);

		// loadingSpinner
		const loadingSpinner = this.add.image(310, 238, "loading-spinner_512x512");
		loadingSpinner.scaleX = 0.1;
		loadingSpinner.scaleY = 0.1;
		loadingContainer.add(loadingSpinner);

		// playerContainer
		const playerContainer = this.add.container(-392, -33);
		mainContainer.add(playerContainer);

		// playerBacking_1
		const playerBacking_1 = this.add.nineslice(0, 0, "panel segment", undefined, 40, 64, 4, 4, 4, 8);
		playerBacking_1.scaleX = 4;
		playerBacking_1.scaleY = 4;
		playerContainer.add(playerBacking_1);

		// image_8
		const image_8 = this.add.image(0, 0, "zone-snippet");
		playerContainer.add(image_8);

		// playerDoll
		const playerDoll = new PlayerDoll(this, 0, 0);
		playerContainer.add(playerDoll);

		// complexionSelection
		const complexionSelection = new ComplexionSelection(this, -60, 201);
		playerContainer.add(complexionSelection);

		// mainButtonsContainer
		const mainButtonsContainer = this.add.container(0, 296);
		mainContainer.add(mainButtonsContainer);

		// saveButton
		const saveButton = new DefaultButton(this, -104, 0);
		mainButtonsContainer.add(saveButton);

		// leaveButton
		const leaveButton = new DefaultDenyButton(this, 104, 0);
		mainButtonsContainer.add(leaveButton);

		// mainLoadingCover
		const mainLoadingCover = this.add.container(-512, -384);
		mainLoadingCover.visible = false;
		mainContainer.add(mainLoadingCover);

		// loadingContainer_1
		const loadingContainer_1 = this.add.container(0, 0);
		mainLoadingCover.add(loadingContainer_1);

		// spinnerBlocker_1
		const spinnerBlocker_1 = this.add.image(0, 0, "1x1sprite");
		spinnerBlocker_1.scaleX = 1024;
		spinnerBlocker_1.scaleY = 768;
		spinnerBlocker_1.setOrigin(0, 0);
		spinnerBlocker_1.alpha = 0.3;
		spinnerBlocker_1.alphaTopLeft = 0.31;
		spinnerBlocker_1.alphaTopRight = 0.3;
		spinnerBlocker_1.alphaBottomLeft = 0.3;
		spinnerBlocker_1.alphaBottomRight = 0.3;
		spinnerBlocker_1.tintTopLeft = 985612;
		spinnerBlocker_1.tintTopRight = 985612;
		spinnerBlocker_1.tintBottomLeft = 985612;
		spinnerBlocker_1.tintBottomRight = 985612;
		loadingContainer_1.add(spinnerBlocker_1);

		// loadingSpinner_1
		const loadingSpinner_1 = this.add.image(512, 384, "loading-spinner_512x512");
		loadingSpinner_1.scaleX = 0.1;
		loadingSpinner_1.scaleY = 0.1;
		loadingContainer_1.add(loadingSpinner_1);

		// noItemsContainer
		const noItemsContainer = this.add.container(160, -192);
		mainContainer.add(noItemsContainer);

		// noItemsFeedbackText
		const noItemsFeedbackText = this.add.bitmapText(0, 0, "Aronui", "Buy new items in the shop!");
		noItemsFeedbackText.setOrigin(0.5, 0);
		noItemsFeedbackText.tintTopLeft = 4864576;
		noItemsFeedbackText.tintTopRight = 4864576;
		noItemsFeedbackText.tintBottomLeft = 4864576;
		noItemsFeedbackText.tintBottomRight = 4864576;
		noItemsFeedbackText.text = "Buy new items in the shop!";
		noItemsFeedbackText.fontSize = -24;
		noItemsFeedbackText.align = 1;
		noItemsContainer.add(noItemsFeedbackText);

		// goToShopButton
		const goToShopButton = new DefaultButton(this, 0, 72);
		noItemsContainer.add(goToShopButton);

		// closeButtonContainer
		const closeButtonContainer = this.add.container(500, -344);
		closeButtonContainer.scaleX = 2;
		closeButtonContainer.scaleY = 2;
		mainContainer.add(closeButtonContainer);

		// closeButton
		const closeButton = new HUDButton(this, -24, 24, "hud-icons", 245);
		closeButtonContainer.add(closeButton);

		// mobileView
		const mobileView = this.add.container(0, 0);

		// uIBlocker_m
		const uIBlocker_m = new UIBlocker(this, -496, 4);
		mobileView.add(uIBlocker_m);

		// mainContainer_m
		const mainContainer_m = this.add.container(334, 188);
		mobileView.add(mainContainer_m);

		// mainBG_m
		const mainBG_m = this.add.nineslice(0, 0, "Hud1", undefined, 302, 156, 8, 8, 8, 8);
		mainBG_m.scaleX = 2;
		mainBG_m.scaleY = 2;
		mainContainer_m.add(mainBG_m);

		// headerContainer_m
		const headerContainer_m = this.add.container(2, -152);
		mainContainer_m.add(headerContainer_m);

		// headerBacking_m
		const headerBacking_m = this.add.nineslice(0, 0, "Hud2", undefined, 80, 20, 4, 4, 4, 8);
		headerBacking_m.scaleX = 2;
		headerBacking_m.scaleY = 2;
		headerContainer_m.add(headerBacking_m);

		// bitmaptext_m
		const bitmaptext_m = this.add.bitmapText(0, 0, "Aronui", "Inventory");
		bitmaptext_m.setOrigin(0.5, 0.5);
		bitmaptext_m.tintTopLeft = 985612;
		bitmaptext_m.tintTopRight = 985612;
		bitmaptext_m.tintBottomLeft = 985612;
		bitmaptext_m.tintBottomRight = 985612;
		bitmaptext_m.text = "Inventory";
		bitmaptext_m.fontSize = -24;
		headerContainer_m.add(bitmaptext_m);

		// shopTabs_m
		const shopTabs_m = this.add.container(-94, -106);
		mainContainer_m.add(shopTabs_m);

		// mainShopGrid_m
		const mainShopGrid_m = this.add.container(-118, -88);
		mainContainer_m.add(mainShopGrid_m);

		// gridBacking_m
		const gridBacking_m = this.add.nineslice(0, 0, "panel segment", undefined, 201, 88, 4, 4, 4, 8);
		gridBacking_m.scaleX = 2;
		gridBacking_m.scaleY = 2;
		gridBacking_m.setOrigin(0, 0);
		mainShopGrid_m.add(gridBacking_m);

		// gridScrollBar_m
		const gridScrollBar_m = this.add.container(394, 0);
		mainShopGrid_m.add(gridScrollBar_m);

		// scrollBarBacking_m
		const scrollBarBacking_m = this.add.nineslice(0, 0, "scrollbar-backing", undefined, 8, 88, 4, 4, 4, 4);
		scrollBarBacking_m.scaleX = 2;
		scrollBarBacking_m.scaleY = 2;
		scrollBarBacking_m.setOrigin(0.5, 0);
		gridScrollBar_m.add(scrollBarBacking_m);

		// scrollBarHandle_m
		const scrollBarHandle_m = this.add.image(0, 0, "scrollbar-handle");
		scrollBarHandle_m.scaleX = 2;
		scrollBarHandle_m.scaleY = 2;
		scrollBarHandle_m.setOrigin(0.5, 0);
		gridScrollBar_m.add(scrollBarHandle_m);

		// content_m
		const content_m = this.add.container(-8, 0);
		mainShopGrid_m.add(content_m);

		// loadingContainer_m
		const loadingContainer_m = this.add.container(0, 0);
		mainShopGrid_m.add(loadingContainer_m);

		// spinnerBlocker_m
		const spinnerBlocker_m = this.add.image(0, 0, "1x1sprite");
		spinnerBlocker_m.scaleX = 402;
		spinnerBlocker_m.scaleY = 176;
		spinnerBlocker_m.setOrigin(0, 0);
		spinnerBlocker_m.alpha = 0.3;
		spinnerBlocker_m.alphaTopLeft = 0.31;
		spinnerBlocker_m.alphaTopRight = 0.3;
		spinnerBlocker_m.alphaBottomLeft = 0.3;
		spinnerBlocker_m.alphaBottomRight = 0.3;
		spinnerBlocker_m.tintTopLeft = 985612;
		spinnerBlocker_m.tintTopRight = 985612;
		spinnerBlocker_m.tintBottomLeft = 985612;
		spinnerBlocker_m.tintBottomRight = 985612;
		loadingContainer_m.add(spinnerBlocker_m);

		// loadingSpinner_m
		const loadingSpinner_m = this.add.image(201, 88, "loading-spinner_512x512");
		loadingSpinner_m.scaleX = 0.1;
		loadingSpinner_m.scaleY = 0.1;
		loadingContainer_m.add(loadingSpinner_m);

		// playerContainer_m
		const playerContainer_m = this.add.container(-206, -8);
		mainContainer_m.add(playerContainer_m);

		// playerBacking_m
		const playerBacking_m = this.add.nineslice(0, 0, "panel segment", undefined, 80, 128, 4, 4, 4, 8);
		playerBacking_m.scaleX = 2;
		playerBacking_m.scaleY = 2;
		playerContainer_m.add(playerBacking_m);

		// scenePreview_m
		const scenePreview_m = this.add.image(0, 0, "zone-snippet");
		playerContainer_m.add(scenePreview_m);

		// playerDoll_m
		const playerDoll_m = new PlayerDoll(this, 0, 0);
		playerDoll_m.scaleX = 6;
		playerDoll_m.scaleY = 6;
		playerContainer_m.add(playerDoll_m);

		// complexionSelection_m
		const complexionSelection_m = new ComplexionSelection(this, -61, 114);
		playerContainer_m.add(complexionSelection_m);

		// itemDescriptionArea_m
		const itemDescriptionArea_m = this.add.container(-206, -132);
		mainContainer_m.add(itemDescriptionArea_m);

		// backing
		const backing = this.add.nineslice(0, 12, "fadeOut2", undefined, 150, 24, 3, 3, 1, 1);
		backing.tint = 5387071;
		itemDescriptionArea_m.add(backing);

		// itemNameLabel_m
		const itemNameLabel_m = this.add.bitmapText(0, 4, "Aronui", "<Item Name>\n");
		itemNameLabel_m.setOrigin(0.5, 0);
		itemNameLabel_m.tintTopLeft = 15130076;
		itemNameLabel_m.tintTopRight = 15130076;
		itemNameLabel_m.tintBottomLeft = 15130076;
		itemNameLabel_m.tintBottomRight = 15130076;
		itemNameLabel_m.text = "<Item Name>\n";
		itemNameLabel_m.fontSize = -12;
		itemNameLabel_m.align = 1;
		itemNameLabel_m.maxWidth = 170;
		itemDescriptionArea_m.add(itemNameLabel_m);

		// mainButtonsContainer_m
		const mainButtonsContainer_m = this.add.container(84, 118);
		mainContainer_m.add(mainButtonsContainer_m);

		// saveButton_m
		const saveButton_m = new DefaultConfirmButton_m(this, -106, 0);
		mainButtonsContainer_m.add(saveButton_m);

		// leaveButton_m
		const leaveButton_m = new DefaultDenyButton_m(this, 104, 0);
		mainButtonsContainer_m.add(leaveButton_m);

		// noItemsContainer_m
		const noItemsContainer_m = this.add.container(90, -56);
		mainContainer_m.add(noItemsContainer_m);

		// noItemsFeedbackText_m
		const noItemsFeedbackText_m = this.add.bitmapText(0, 0, "Aronui", "Buy new items in the shop!");
		noItemsFeedbackText_m.setOrigin(0.5, 0);
		noItemsFeedbackText_m.tintTopLeft = 4864576;
		noItemsFeedbackText_m.tintTopRight = 4864576;
		noItemsFeedbackText_m.tintBottomLeft = 4864576;
		noItemsFeedbackText_m.tintBottomRight = 4864576;
		noItemsFeedbackText_m.text = "Buy new items in the shop!";
		noItemsFeedbackText_m.fontSize = -24;
		noItemsFeedbackText_m.align = 1;
		noItemsContainer_m.add(noItemsFeedbackText_m);

		// goToShopButton_m
		const goToShopButton_m = new DefaultConfirmButton_m(this, 0, 72);
		noItemsContainer_m.add(goToShopButton_m);

		// closeButtonContainer_m
		const closeButtonContainer_m = this.add.container(302, -156);
		closeButtonContainer_m.visible = false;
		mainContainer_m.add(closeButtonContainer_m);

		// closeButton_m
		const closeButton_m = new HUDButton(this, -27, 29, "hud-icons", 245);
		closeButtonContainer_m.add(closeButton_m);

		// mainLoadingCover_m
		const mainLoadingCover_m = this.add.container(-512, -384);
		mainLoadingCover_m.visible = false;
		mainContainer_m.add(mainLoadingCover_m);

		// loadingContainer_1_m
		const loadingContainer_1_m = this.add.container(0, 0);
		mainLoadingCover_m.add(loadingContainer_1_m);

		// spinnerBlocker_1_m
		const spinnerBlocker_1_m = this.add.image(0, 0, "1x1sprite");
		spinnerBlocker_1_m.scaleX = 1024;
		spinnerBlocker_1_m.scaleY = 768;
		spinnerBlocker_1_m.setOrigin(0, 0);
		spinnerBlocker_1_m.alpha = 0.3;
		spinnerBlocker_1_m.alphaTopLeft = 0.31;
		spinnerBlocker_1_m.alphaTopRight = 0.3;
		spinnerBlocker_1_m.alphaBottomLeft = 0.3;
		spinnerBlocker_1_m.alphaBottomRight = 0.3;
		spinnerBlocker_1_m.tintTopLeft = 985612;
		spinnerBlocker_1_m.tintTopRight = 985612;
		spinnerBlocker_1_m.tintBottomLeft = 985612;
		spinnerBlocker_1_m.tintBottomRight = 985612;
		loadingContainer_1_m.add(spinnerBlocker_1_m);

		// loadingSpinner_1_m
		const loadingSpinner_1_m = this.add.image(512, 384, "loading-spinner_512x512");
		loadingSpinner_1_m.scaleX = 0.1;
		loadingSpinner_1_m.scaleY = 0.1;
		loadingContainer_1_m.add(loadingSpinner_1_m);

		// saveButton (prefab fields)
		saveButton.buttonText = "Save";

		// leaveButton (prefab fields)
		leaveButton.buttonText = "Leave";

		// goToShopButton (prefab fields)
		goToShopButton.buttonText = "Go to Shop";

		// saveButton_m (prefab fields)
		saveButton_m.buttonText = "Save";

		// leaveButton_m (prefab fields)
		leaveButton_m.buttonText = "Leave";

		// goToShopButton_m (prefab fields)
		goToShopButton_m.buttonText = "Go To Shop";

		this.shopTabs = shopTabs;
		this.itemNameLabel = itemNameLabel;
		this.gridBacking = gridBacking;
		this.scrollBarBacking = scrollBarBacking;
		this.scrollBarHandle = scrollBarHandle;
		this.content = content;
		this.loadingSpinner = loadingSpinner;
		this.loadingContainer = loadingContainer;
		this.playerDoll = playerDoll;
		this.complexionSelection = complexionSelection;
		this.saveButton = saveButton;
		this.leaveButton = leaveButton;
		this.mainLoadingCover = mainLoadingCover;
		this.goToShopButton = goToShopButton;
		this.noItemsContainer = noItemsContainer;
		this.closeButton = closeButton;
		this.mainContainer = mainContainer;
		this.desktopView = desktopView;
		this.shopTabs_m = shopTabs_m;
		this.gridBacking_m = gridBacking_m;
		this.scrollBarBacking_m = scrollBarBacking_m;
		this.scrollBarHandle_m = scrollBarHandle_m;
		this.content_m = content_m;
		this.loadingSpinner_m = loadingSpinner_m;
		this.loadingContainer_m = loadingContainer_m;
		this.playerDoll_m = playerDoll_m;
		this.complexionSelection_m = complexionSelection_m;
		this.itemNameLabel_m = itemNameLabel_m;
		this.saveButton_m = saveButton_m;
		this.leaveButton_m = leaveButton_m;
		this.goToShopButton_m = goToShopButton_m;
		this.noItemsContainer_m = noItemsContainer_m;
		this.closeButton_m = closeButton_m;
		this.mainLoadingCover_m = mainLoadingCover_m;
		this.mainContainer_m = mainContainer_m;
		this.mobileView = mobileView;

		this.events.emit("scene-awake");
	}

	public shopTabs!: Phaser.GameObjects.Container;
	public itemNameLabel!: Phaser.GameObjects.BitmapText;
	public gridBacking!: Phaser.GameObjects.NineSlice;
	public scrollBarBacking!: Phaser.GameObjects.NineSlice;
	public scrollBarHandle!: Phaser.GameObjects.Image;
	public content!: Phaser.GameObjects.Container;
	public loadingSpinner!: Phaser.GameObjects.Image;
	public loadingContainer!: Phaser.GameObjects.Container;
	public playerDoll!: PlayerDoll;
	public complexionSelection!: ComplexionSelection;
	public saveButton!: DefaultButton;
	public leaveButton!: DefaultDenyButton;
	public mainLoadingCover!: Phaser.GameObjects.Container;
	public goToShopButton!: DefaultButton;
	public noItemsContainer!: Phaser.GameObjects.Container;
	public closeButton!: HUDButton;
	public mainContainer!: Phaser.GameObjects.Container;
	public desktopView!: Phaser.GameObjects.Container;
	public shopTabs_m!: Phaser.GameObjects.Container;
	public gridBacking_m!: Phaser.GameObjects.NineSlice;
	public scrollBarBacking_m!: Phaser.GameObjects.NineSlice;
	public scrollBarHandle_m!: Phaser.GameObjects.Image;
	public content_m!: Phaser.GameObjects.Container;
	public loadingSpinner_m!: Phaser.GameObjects.Image;
	public loadingContainer_m!: Phaser.GameObjects.Container;
	public playerDoll_m!: PlayerDoll;
	public complexionSelection_m!: ComplexionSelection;
	public itemNameLabel_m!: Phaser.GameObjects.BitmapText;
	public saveButton_m!: DefaultConfirmButton_m;
	public leaveButton_m!: DefaultDenyButton_m;
	public goToShopButton_m!: DefaultConfirmButton_m;
	public noItemsContainer_m!: Phaser.GameObjects.Container;
	public closeButton_m!: HUDButton;
	public mainLoadingCover_m!: Phaser.GameObjects.Container;
	public mainContainer_m!: Phaser.GameObjects.Container;
	public mobileView!: Phaser.GameObjects.Container;

	/* START-USER-CODE */

  preload() {
    // Make sure all assets are loaded.
    const unlockedItems = getCharacterInventory().unlockedItems;
    const customizations = Customizations as Customization[];
    const unlockedCosmetics = customizations.filter((c) =>
      unlockedItems.find((i: number) => c.id === i),
    );
    unlockedCosmetics.forEach((c) => {
      loadCustomizationTextures(this, c);
    });
  }

  init() {}

  create() {
    this.editorCreate();
    new PlayerInventoryController(this);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
